import template from './templates/luggageForm.tmpl.html';
import tripEvents from './../config/events.constant';

export default function LuggageForm(
    $compile,
    $rootScope,
    tripFactory,
    l10nService,
    luggageService,
    userService,
    travellerUtils
) {
    'ngInject';

            return {
                restrict: 'E',
                template,
                scope: {
                    traveller: '=',
                    readonly: '=',
                    config: '=',
                    flights: '=',
                    discountedLuggage: '=',
                },
                link: function(scope) {

                    luggageService.luggageConfig = scope.config;
                    scope.regionalSettings = userService.getRegionalSettings();

                    /**
                     * Get traveller Id
                     */
                    const travellerId = scope.traveller.Id || scope.traveller.TripPassengerId;

                    /**
                     * Create luggage model
                     */
                    scope.luggageModel = (tripFactory.isLuggageModelRegistered(travellerId))
                        ? tripFactory.getLuggageModel(travellerId)
                        : luggageService.createModel(scope.config, scope.flights, scope.traveller);

                    scope.l10n = l10nService;
                    scope.regionalSettings = userService.getRegionalSettings();
                    scope.getFullName = travellerUtils.getTravellerFullName;
                    scope.discountedLuggageAtLeastOneTime = {};
                    scope.isLuggageDiscounted = function(flightGroupId, flightId) {
                        const isChildLuggageDiscounted = _.find(scope.discountedLuggage, {
                            TripItemFlightGroupId: flightGroupId,
                            TripItemFlightRecommendationId: flightId,
                            TripPassengerId: travellerId,
                        });

                        if (!scope.isLuggageWasDiscounted && isChildLuggageDiscounted) {
                            _.set(scope.discountedLuggageAtLeastOneTime,
                                flightGroupId + '.' + flightId,
                                true);
                        }

                        return isChildLuggageDiscounted;
                    };
                    scope.isDiscountAppliedForLuggage = function() {
                        return scope.discountedLuggage && scope.discountedLuggage.length;
                    };

                    scope.wasLuggageDiscountedAtLeastOneTime = function(flightGroupId, flightId) {
                        return _.get(scope.discountedLuggageAtLeastOneTime, flightGroupId + '.' + flightId);
                    };

                    scope.getDiscountAmount = function(flightRecommendationId, luggageItemId) {
                        const flightLuggageOptions = _.find(scope.config,
                                                            {TripItemFlightRecommendationId: flightRecommendationId});
                        const defaultPrice = _.chain(flightLuggageOptions.Options)
                            .find({Id: luggageItemId})
                            .get('Amount')
                            .value();

                        return defaultPrice;
                    };

                    scope.isAdult = luggageService.isAdult(scope.traveller);
                    scope.isLuggageAvailable = luggageService.isLuggageAvailableForTraveller(scope.config, travellerId);
                    scope.isFlightLuggageAvailable = luggageService.isLuggageAvailableForFlightGroupId.bind(luggageService, scope.config);
                    scope.luggageService = luggageService;
                    scope.isFlightLuggageEnabledForFlight = function(flightId) {
                        return luggageService.getLuggageConfigByFlightId(flightId);
                    };

                    scope.generateBagsData = luggageService.generateBagsData.bind(luggageService, scope.config);
                    scope.checkLinkedModels = luggageService.checkLinkedModels.bind(luggageService, tripFactory, scope.config, travellerId);

                    function luggageWatcher(newLuggageModel, oldLuggageModel) {
                        if (newLuggageModel === oldLuggageModel) {
return;
}
                        $rootScope.$emit(tripEvents.LUGGAGE_CHANGED);
                    }

                    scope.$watch('luggageModel', luggageWatcher, true);

                    tripFactory.registerModel(travellerId, scope.luggageModel);
                },
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/directives/luggageForm.directive.js